import { formatTime, timeValueKind } from 'shared/time/businessTime';
/** Readable fallbacks for authored identifiers; never translate business meaning. */
export const reviewLabel = (value) => {
  const words = String(value || '')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ');
  return words ? words[0].toUpperCase() + words.slice(1) : '';
};

/**
 * A review never silently shifts a value: calendar dates stay on their day,
 * wall-clock values stay as written, and instants show in the business time
 * zone with the zone named.
 */
export const reviewValue = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'number') return String(value);
  if (typeof value === 'object') return JSON.stringify(value);
  const text = String(value);
  if (!timeValueKind(text)) return text;
  return formatTime(
    text,
    { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit' },
    { label: true },
  );
};
